export function getJobStatusURL(jobId: string | undefined): string | undefined {
	if (!jobId) {
		return undefined;
	}

	return `/authenticated/data/jobs/${jobId}`;
}
